import { Address } from './../types/index';
import { User } from '../types';
import { REMOVE_USER, SET_USER, ADD_USER_ADDRESS, SET_USERS_FOLLOW, REMOVE_USER_FOLLOW, ADD_USER_FOLLOW } from '../actions/auth';

export type AuthState = {
  isAuthenticated: boolean;
  user: User | null;
  usersFollow: number[];
  addNewAddress:boolean;
};

const defaultState = {
  isAuthenticated: false,
  user: null,
  usersFollow: [],
  addNewAddress:false,
};

export default (state: AuthState = defaultState, action: any) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: true,
      };

    case REMOVE_USER:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };

    case ADD_USER_ADDRESS:
      return {
        ...state,
        user: {
          ...state.user,
          addresses: [...state.user!.addresses,action.payload.address],
        },
        addNewAddress:true,
      };
    case SET_USERS_FOLLOW:
      return {
        ...state,
        usersFollow: action.payload.usersId,
      };

    case REMOVE_USER_FOLLOW:
      let usersFollow = [...state.usersFollow]
      let index = usersFollow.indexOf(action.payload.userId)
      if (index != -1) {
        usersFollow.splice(index, 1);
      }
      return {
        ...state,
        usersFollow: usersFollow,
      };


    case ADD_USER_FOLLOW:
      return {
        ...state,
        usersFollow: [...state.usersFollow, action.payload.userId],
      };

    default:
      return state;
  }
};
